import style from './Tools.module.css';
import { MapSelect } from '../../Components/Select/MapSelect';
import { useSelector, useDispatch } from 'react-redux';
import { setVendorActiveTag } from '../../Redux/Slices/Vendors';
import { openOrClose } from '../../Redux/Slices/Select/Select';

export default function Tools({stat = false}) {
    const vendorActiveTag = useSelector(state => state.vendor.vendorActiveTag)
    const vendors = useSelector(state => state.vendor.vendors)
    const MapSelectState = useSelector((state) => state.select.MapSelect)
    const dispatch = useDispatch()   
    
    return <div className={`${style.container} ${stat && style.stat_container}`}>
        <MapSelect options={vendors} value={vendorActiveTag} isOpen={MapSelectState} setIsOpen={() => dispatch(openOrClose('MapSelect'))} setValue={(item) => dispatch(setVendorActiveTag(item))}/>
        <div className={`${style.search_container} `}>
        </div>
    </div>
}